import { Pipe, PipeTransform } from '@angular/core';
import { ProjectJobContractTypeSchema } from '@vmspdb/definitions';
import { AbstractEnumPipe } from './abstract-enum.pipe';

@Pipe({
  name: 'enumProjectJobContractType',
  standalone: false,
})
export class EnumProjectJobContractTypePipe
  extends AbstractEnumPipe
  implements PipeTransform
{
  readonly enum = ProjectJobContractTypeSchema;
}
